import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import { homeServicesConfig as homeServicesStaticContent } from 'reaxl-home-services';
import { SubHeading } from 'reaxl';
import { Checkbox } from 'reaxl-forms';
import EmailStaticContent from '../EmailStaticContent';
import EmailContext from '../EmailContext';
const homeServicesOrder = ['virtualTour', 'testDrive', 'vehicleDelivery'];
function OptInService(_ref) {
  let {
    isSelected = false,
    name,
    title
  } = _ref;
  if (title.includes('Delivery')) {
    title = 'Delivery';
  }
  return /*#__PURE__*/_jsx(Checkbox, {
    name: name,
    label: title,
    value: isSelected,
    rowClassName: "margin-bottom-0"
  });
}

/**
 *  HomeServicesOptIn renders a subheading and checkboxes for the At Home Services options a user can select
 *  in a lead form
 */
const HomeServicesOptIn = /*#__PURE__*/memo(_ref2 => {
  let {
    preSelectedService
  } = _ref2;
  const {
    owner: {
      homeServices = {}
    } = {}
  } = useContext(EmailContext);
  if (!homeServicesOrder.includes(preSelectedService)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(SubHeading, {
    size: 300,
    color: "subdued-lighter"
  }, void 0, EmailStaticContent.sectionHeading.dhs), homeServicesOrder.map(service => homeServices[service] && /*#__PURE__*/React.createElement(OptInService, Object.assign({
    key: service,
    isSelected: service === preSelectedService
  }, homeServicesStaticContent[service]))));
});
export default HomeServicesOptIn;